import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { DropDown } from '../../components/DropDown';
import { DropDownItem } from '../../components/DropDownItem';
import { useAppSelector } from '../../hooks/useRedux';
import { API_URL } from '../../utils/constants';
import StudentCard from './StudentCard';

interface ICat {
  name: string[];
}

export interface Student {
  _id: string;
  category: ICat;
  categoryType: string;
  user: {
    _id: string;
    email: string;
    profilePic: string;
    name: string;
    phoneNumber: string;
    timezone: string;
    createdAt: string;
    updatedAt: string;
  };
}

function MyStudents() {
  const { profile } = useAppSelector((state) => state.profileSlice);
  const [students, setStudents] = useState<Student[]>([]);
  const [data, setData] = useState<Student[]>([]);
  const [courses, setCourses] = useState<string[]>([]);
  const [searchParams, setSearchParams] = useSearchParams();

  const getTrainerStudents = () => {
    fetch(`${API_URL}/t/students?_id=${profile?._id}`, {
      credentials: 'include'
    })
      .then((res) => res.json())
      .then((res) => {
        if (res) {
          let tempIds: string[] = [];
          let temp: Student[] = [];
          res.data.forEach((item: any) => {
            if (!tempIds.includes(item.user.email)) {
              temp.push(item);
              tempIds.push(item.user.email);
            }
          });
          setStudents(temp);
          let tempCourses: string[] = [];
          res.data.forEach((slot: any) => {
            // if (!tempCourses.includes(slot.course)) {
            //   tempCourses.push(slot.course);
            // }
            tempCourses.push(...slot.category.name);
          });
          setCourses(Array.from(new Set(tempCourses)));
        }
      })
      .catch((err) => err);
  };

  useEffect(() => {
    if (profile) {
      getTrainerStudents();
    }
  }, [profile]);

  useEffect(() => {
    setData(students);
  }, [students]);

  const filterByCategory = (course: string) => {
    let temp = [...students];
    setData(temp.filter((item) => item.category.name.includes(course)));
    setSearchParams({ course: course });
  };

  return (
    <div className="p-8 w-full h-full min-h-screen ">
      <div className="bg-white rounded-md shadow-md">
        <h2 className="font-bold text-2xl p-4">{`My Students`}</h2>
        <div className="w-full bg-gray-100 px-4 py-2 flex items-center gap-7">
          <h3 className="text-base text-gray-800">Filter</h3>
          <div className="w-full max-w-[200px]">
            <DropDown
              content={
                <p className="text-sm">{searchParams.get('course') ? searchParams.get('course') : 'Category'}</p>
              }
            >
              {courses.map((course, index) => (
                <DropDownItem key={index} item={course} handleChange={(value) => filterByCategory(value)} />
              ))}
            </DropDown>
          </div>
        </div>
        <div className="w-full my-5 px-10 py-4 flex items-center justify-between">
          {data.length === 0 ? (
            <div className="w-full min-h-[300px] bg-white  flex items-center justify-center rounded-md">
              <h1 className="text-2xl font-semibold text-center">No Students Found.</h1>
            </div>
          ) : (
            <div className="w-full h-full grid grid-cols-1 sm:grid-cols-2  md:grid-cols-4 auto-rows-fr">
              {data.map((student) => (
                <StudentCard key={student._id} student={student} />
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default MyStudents;
